const statuses = [
  {
    name: 'Active',
    icon: 'como-ic-ok',
    messageId: 'status.active'
  },
  {
    name: 'Deactivate',
    icon: 'como-ic-deactivate',
    messageId: 'status.deactivated'
  },
  {
    name: 'Freeze',
    icon: 'como-ic-deactivate',
    messageId: 'status.freeze'
  },
  {
    name: 'Test',
    icon: 'como-ic-test',
    messageId: 'status.test'
  },
  {
    name: 'delete',
    icon: 'como-ic-delete',
    messageId: 'status.delete'
  },
];

export const getStatusObject = (name) => {
  return statuses.find((item) => item.name === name) || null;
};

